import React from 'react';
import '../TaskRow.css';

function CollapsedTaskRow({ combinedRef, attributes, listeners }) {
  return (
    <li className="task-item task-item-collapsed" ref={combinedRef} {...attributes} {...listeners}>
      <div className="task-content">
        <span className="task-collapsed-spacer"></span>
        <div className="task-collapsed-line"></div>
      </div>
    </li>
  );
}

export default CollapsedTaskRow;
